import React from 'react';
import AuthenticatedLayoutRoute from '../../layout/AuthenticatedLayoutRoute';

const Dashboard = React.lazy(() => import(/* webpackChunkName: "Dashboard" */ '.'));

const routes = [
    <AuthenticatedLayoutRoute path="/" exact key="dashboard">
        <Dashboard />
    </AuthenticatedLayoutRoute>,
];

export default routes;
